import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/http-models/api-response';
import { API_CONSTANTS } from '../base/api-constants';
import { BaseService } from '../base/base-service';
import {
  decodeBase64Url,
  decodeJwtPayload,
  permissionsFromJwtPayload,
  PortalUserType,
  staffRoleFromJwtPayload,
  userTypeFromJwtPayload,
} from '../../utils/jwt-auth.util';


@Injectable({
  providedIn: 'root'
})

export class AuthenticationService extends BaseService {


  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  jwtHelper = new JwtHelperService();

  setToken(token: string, refreshToken: string) {
    localStorage.setItem("access_token", token);
    localStorage.setItem("refresh_token", refreshToken);
  }

  setAuthorizationToken(token: string) {
    localStorage.setItem("auth_token", token);
  }

  setSessionToken(token: string) {
    sessionStorage.setItem("access_token", token);
  }

  getToken(): any {
    const token = localStorage.getItem("access_token");
    if (token) {
      return token;
    }
    else {
      const token = sessionStorage.getItem("access_token");
      if (token) {
        return token;
      }
    }
  }

  RefreshAccessToken(): Observable<HttpEvent<ApiResponse>> {
    const model = {
      refreshToken: localStorage.getItem("refresh_token")
    }
    return this.post(API_CONSTANTS.Auth.RefreshAccessToken, model);
  }

  ChangePassword(model: { password: string; newPassword: string }): Observable<HttpEvent<ApiResponse>> {
    return this.post(API_CONSTANTS.Auth.ChangePassword, model);
  }


  removeToken(): void {
    localStorage.removeItem("access_token");
    sessionStorage.removeItem("refresh_token");
  }

  private getDecodedToken(): Record<string, unknown> | null {
    const token = this.getToken();
    if (!token) {
      return null;
    }
    return this.jwtHelper.decodeToken(token) as Record<string, unknown> | null;
  }

  getUserType(): PortalUserType | undefined {
    return userTypeFromJwtPayload(this.getDecodedToken());
  }

  /** Portal role for routing (Candidate / Provider / Moderator). */
  getUserRole(): string | undefined {
    return this.getUserType();
  }

  getStaffRole(): string | undefined {
    return staffRoleFromJwtPayload(this.getDecodedToken());
  }

  getPermissions(): string[] {
    return permissionsFromJwtPayload(this.getDecodedToken());
  }

  hasPermission(permission: string): boolean {
    if (!permission?.trim()) {
      return false;
    }
    return this.getPermissions().includes(permission);
  }

  isStaff(): boolean {
    return this.getUserType() === 'Moderator';
  }

  getUserID() {
    const token = this.getToken();
    if (token) {
      const { nameid } = this.jwtHelper.decodeToken(token);
      return nameid;
    }
  }


  getUserAuthModel(): string {
    const userDetails = this.getUserDetailsViaToken();
    if (!userDetails) {
      return "False";
    }
    return userDetails.AuthModel;
  }

  isAuthenticated(): boolean {
    try {
      const token = this.getToken();
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        return true;
      }
      return false;
    }
    catch {
      return false;
    }
  }

  isInRole(roleName: string): boolean {
    return this.getUserType() === roleName;
  }

  getUserDetailsViaToken(): any {
    const token = this.getToken();
    if (!token) {
      return undefined;
    }
    return decodeJwtPayload(token) ?? undefined;
  }

  decodeUserAuthorizations(): any {
    const authToken = localStorage.getItem("auth_token");
    if (!authToken) {
      return undefined;
    }
    try {
      const parsed = JSON.parse(decodeBase64Url(authToken));
      return typeof parsed === 'string' ? JSON.parse(parsed) : parsed;
    } catch {
      return undefined;
    }
  }

  //Authentications

  logout() {
    this.removeToken();
    localStorage.clear();
    // this.navService.MENUITEMS = [];
  }

}
